@if (user()) {
<div class="side-top">
  @if (!isChallenger()) {
  <div class="side-top__modes">
    <button [class.active]="!vault()" (click)="toggleVault(false)">
      King's items
    </button>
    <button [class.active]="vault()" (click)="toggleVault(true)">
      King's vault
    </button>
  </div>
  }
  <div class="side-top__values">
    <div class="side-top__values--items">
      <svg
        width="14"
        height="13"
        viewBox="0 0 14 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.3333 3.58806V9.42939C13.3333 9.68189 13.1907 9.91272 12.9648 10.0257L7 13.0081V6.75472L8.5 6.00472V9.13139C8.5 9.27805 8.595 9.40639 8.73334 9.44972C8.76667 9.45972 8.8 9.46472 8.83334 9.46472C8.94 9.46472 9.04334 9.41305 9.10667 9.32139L10.415 7.43306L11.3067 8.06972C11.4083 8.14139 11.5417 8.15139 11.6533 8.09472C11.7633 8.03806 11.8333 7.92306 11.8333 7.79806V4.33806L13.3333 3.58806ZM6.36867 0.0702292L5.32834 0.589729L11.5833 3.71639L12.9217 3.04806L6.96467 0.0703957C6.777 -0.0234375 6.55634 -0.0234374 6.36867 0.0702292ZM9.16667 5.67139V8.06472L10.06 6.77472C10.11 6.70139 10.1883 6.65139 10.2767 6.63639C10.3633 6.62139 10.455 6.64139 10.5267 6.69306L11.1667 7.14972V4.67139L9.16667 5.67139ZM4.58333 0.963062L2.66167 1.92306L8.91667 5.04972L10.8383 4.08973L4.58333 0.963062ZM1.91667 2.29639L0.411667 3.04806L6.66667 6.17472L8.17167 5.42306L1.91667 2.29639ZM0 3.58806V9.42939C0 9.68189 0.142667 9.91272 0.3685 10.0257L6.33334 13.0081V6.75472L0 3.58806Z"
          fill="currentColor"
        />
      </svg>
      <span typography>
        {{ kingSkins().length }}
      </span>
    </div>
    <div class="side-top__values--price">
      <app-cost
        color="var(--red)"
        [cost]="skinsValue()"
        [balanceType]="'skins'"
      />
    </div>
    <div class="side-top__values--mode">
      <span>{{ user()?.type === 0 ? "Fight" : "Vault" }} Mode</span>
    </div>
  </div>
</div>
<app-skins-list
  class="skins"
  [skins]="kingSkins()"
  [config]="{
    skin_min_width: '120px',
    mobile: {
      padding: '10px',
      skin_min_width: '100%',
    },
  }"
/>
<!--  -->
} @else {
<button class="placeholder" (click)="openModal()">
  <img
    [alt]="isChallenger() ? 'challenger' : 'king'"
    [src]="
      isChallenger()
        ? 'assets/images/king/common/challenger-skins-placeholder.png'
        : 'assets/images/king/common/king-skins-placeholder.png'
    "
    loading="lazy"
  />
  <span>
    {{
      isChallenger()
        ? "Challenge the Reigning King to take what’s rightfully yours!"
        : "Become the King and defend your Glory!... and your skins"
    }}
  </span>
</button>
}
